<template>
  <div
    class="flex flex-col items-center p-40 my-40 border rounded border-grey-300"
  >
    <div
      class="flex items-center justify-center rounded-full h-125 w-125 bg-sky-100"
    >
      <Icon
        iconClass="fas fa-check-circle text-sky-500"
        :style="{ fontSize: '65px' }"
      />
    </div>
    <h6 class="text-center pt-20">
      {{ displaySuccessMessage }}
    </h6>
  </div>
</template>

<script>
import { MFA_TYPES } from '@platform-shared/constants'

export default {
  props: {
    mfaPreference: {
      type: String,
      required: true,
    },
  },
  computed: {
    displaySuccessMessage() {
      return this.mfaPreference === MFA_TYPES.EMAIL
        ? this.$t('mfa.modality.verified.email')
        : this.$t('mfa.modality.verified.phone')
    },
  },
}
</script>
